<template>
  <div class="full-height full-width row">
    <q-drawer
      v-model="state.left.show"
      :mini="!state.left.show || state.left.miniState"
      :width="220"
      :breakpoint="500"
      bordered
      content-class="bg-white column"
    >
      <q-scroll-area class="col">
        <q-list padding>
          <q-item v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label>OCR</q-item-label>
              <q-item-label caption style="padding-bottom:8px">
                이미지에 포함된 문자열 영역을 찾고 해당 영역의 문자열을 인식합니다.
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-separator v-show="state.left.miniState == false" />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                테스트
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item :active="state.page.value == 'hwr-view'" clickable v-ripple @click="state.page.value = 'hwr-view'">
            <q-item-section avatar>
              <q-icon name="gesture" />
            </q-item-section>

            <q-item-section>
              OCR - 필기
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">OCR - handwriting</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'ocr-view'" clickable v-ripple @click="state.page.value = 'ocr-view'">
            <q-item-section avatar>
              <q-icon name="spellcheck" />
            </q-item-section>

            <q-item-section>
              OCR - Natural scene
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">OCR</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'ocr-doc-view'" clickable v-ripple @click="state.page.value = 'ocr-doc-view'">
            <q-item-section avatar>
              <q-icon name="table_chart" />
            </q-item-section>

            <q-item-section>
              OCR - 문서(A4)
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">OCR - 문서(A4)</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'paddle-ocr-view'" clickable v-ripple @click="state.page.value = 'paddle-ocr-view'" v-show="isDev">
            <q-item-section avatar>
              <q-icon name="science" />
            </q-item-section>

            <q-item-section>
              Paddle OCR
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">Paddle OCR</q-tooltip>
          </q-item>
          <q-item :active="state.page.value == 'math-ocr-view'" clickable v-ripple @click="state.page.value = 'math-ocr-view'">
            <q-item-section avatar>
              <q-icon name="calculate" />
            </q-item-section>

            <q-item-section>
              수식 OCR
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">수식 OCR</q-tooltip>
          </q-item>  
        </q-list>
      </q-scroll-area>
      <q-separator />
      <q-item clickable v-ripple @click="state.left.miniState = !state.left.miniState">
        <q-item-section avatar>
          <q-icon v-if="state.left.miniState == false" name="chevron_left" />
          <q-icon v-else name="chevron_right" />
        </q-item-section>

        <q-item-section style="color:rgb(125, 125, 125);font-size:12px;">
          POWERED BY SELVAS AI
        </q-item-section>
      </q-item>
    </q-drawer>

    <q-page-container class="column col full-height full-width">
      <q-page class="column col full-height full-width" style="background:rgb(237, 238, 242);overflow:auto;">
        <ocr-view v-if="state.page.value == 'ocr-view'"
          :key="'hwr'"
          ref='ocr-view'
          :recognition-type="'ocr'"
        />
        <ocr-view v-if="state.page.value == 'hwr-view'"
          :key="'ocr'"
          ref='hwr-view'
          :recognition-type="'hwr'"
        />
        <ocr-view v-if="state.page.value == 'ocr-doc-view'"
          :key="'ocr-doc'"
          ref='ocr-doc-view'
          :recognition-type="'ocr-doc'"
        />
        <paddle-ocr-view v-if="state.page.value == 'paddle-ocr-view'"/>
        <math-ocr-view v-if="state.page.value == 'math-ocr-view'" />
      </q-page>
    </q-page-container>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import OcrView from '@/projects/ocr/views/OcrView.vue'
import PaddleOcrView from '@/projects/ocr/views/PaddleOcrView.vue'
import MathOcrView from '@/projects/ocr/views/MathOcrView.vue'
import ETC from '@/js/etc.js'

export default {
  name: 'App',
  data: function () {
    return {
      state: {
        left: {
          show: true,
          miniState: false
        },
        page: {
          value: 'ocr-view'
        }
      }
    }
  },
  components: {
    OcrView,
    PaddleOcrView,
    MathOcrView
  },
  methods: {
  },
  computed: {
    isDev() {
      return ETC.isDev()
    }
  },
  async mounted () {
    /*
    fetch('https://127.0.0.1/api/image/123.pdf')
    .then((response) => response.blob())
    .then(blob => {
      let file = new File([blob], '123.pdf')
      this.$dialogPdftoImage.show(file, (data) => console.log(data))
    })
    */
  }
}
</script>

<style>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  overflow: auto;
  background: rgb(239, 239, 239);
}

.body {
  display:flex;
  flex-direction:column;
  height:100%;
  width:100%;
  background: rgb(237, 238, 241);
}

.q-toggle__thumb {
  color: red !important;
}

.q-toggle__thumb:after {
  background: rgb(230, 230, 230) !important;
}

.q-toggle__inner--indet .q-toggle__thumb:after {
  background: rgb(3, 169, 244) !important;
}

.q-toggle__inner--truthy .q-toggle__thumb:after {
  background: #027BE3 !important;
}

.q-toggle__inner.q-toggle__inner--indet {
  color:rgb(41, 182, 246);
}

::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar
{
	width: 6px;
  height: 6px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
}

</style>
